import React, { Component } from "react";
import JWPlayerOnScrollViewResize from "./JWPlayerOnScrollViewResize";
import ReactJWPlayer from "react-jw-player";

class Live extends Component {
  constructor(props) {
    super(props);
    console.log("props in live page", props);
  }

  /*playerReady(e) {
    if (!this.isMobile) JWPlayerOnScrollViewResize();
  }*/

  playerError(e) {}

  render() {
    return (
      <section
        id="main-section"
        className="px-lg-0 jc-inner-page align-self-start"
      >
        <div className="card p-3">
          <h1>The Dugout Show</h1>
        </div>
        <div className="card p-2">
          <div className="player-container mb-2 w-100">
            <div className="player-position">
              <ReactJWPlayer
                playerId="player"
                playerScript="https://content.jwplatform.com/libraries/IDzF9Zmk.js"
                file="https://32x2cn7zz29m47vnqt4z-kyz6hw.p5cdn.com/abr_PSLME/paknz2021/playlist.m3u8"
                onReady={this.playerReady}
                onError={this.playerError}
                isMuted= {false}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Live;
